import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type useSignableContractDefaultSignersProps<T> = {
  filters?: {
    search?: string
  }
  mapper?: (data: any) => T
}

export const useSignableContractDefaultSigners = <T,>({
  filters: { search = '' } = {},
  mapper = Mapper.default<T>(),
}: useSignableContractDefaultSignersProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['signableContractDefaultSigners', search],
    queryFn: () => {
      const params = {
        'q[designation_eq]': search,
      }

      return privateAxios.get('/signable_contract/default_signers', {
        params,
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}
